// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"643560af","455":"8d7df9e7","977":"4dd6e646"}[chunkId] + ".chunk.js";
};